var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDayShift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.01 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "day-shift") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "day_shift",
    "data-name": "day shift",
    fill: "current",
    d: "M17.54,8.73a8.77,8.77,0,1,0,8.77,8.77h0A8.78,8.78,0,0,0,17.54,8.73Zm0-2.58a1.71,1.71,0,0,1-1.71-1.71V1.71a1.71,1.71,0,0,1,3.42,0V4.45a1.71,1.71,0,0,1-1.71,1.71Zm0,22.69a1.71,1.71,0,0,0-1.71,1.71v2.74a1.71,1.71,0,0,0,3.42,0V30.56A1.71,1.71,0,0,0,17.54,28.84Zm8-19.37a1.71,1.71,0,0,1,0-2.42h0L27.5,5.12A1.71,1.71,0,0,1,30,7.51l0,0L28,9.48a1.71,1.71,0,0,1-2.42,0h0Zm-16,16a1.71,1.71,0,0,0-2.42,0h0L5.17,27.46a1.71,1.71,0,0,0,2.42,2.42h0l1.94-1.94a1.71,1.71,0,0,0,0-2.42Zm19.37-8a1.71,1.71,0,0,1,1.71-1.71h2.74a1.71,1.71,0,0,1,0,3.42H30.6a1.71,1.71,0,0,1-1.71-1.71ZM6.2,17.5a1.71,1.71,0,0,0-1.71-1.71H1.75a1.71,1.71,0,0,0-.08,3.42H4.49A1.71,1.71,0,0,0,6.2,17.5Zm19.37,8a1.86,1.86,0,0,1,2.42,0h0l1.94,1.93a1.71,1.71,0,0,1-2.42,2.42l-1.93-1.93A1.79,1.79,0,0,1,25.56,25.52Zm-16-16a1.71,1.71,0,0,0,0-2.42h0L7.59,5.12A1.71,1.71,0,1,0,5.17,7.54L7.1,9.48a1.71,1.71,0,0,0,2.42,0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayShift);
export default __webpack_public_path__ + "static/media/dayShift.96418521.svg";
export { ForwardRef as ReactComponent };